import { Component, input, output } from '@angular/core';

@Component({
  selector: 'mbp-toggle',
  templateUrl: './mbp-toggle.component.html',
  styleUrl: './mbp-toggle.component.scss'
})
export class MbpToggleComponent {
  ariaLabel = input<string>('');
  checked = input<boolean>(false);
  disabled = input<boolean>(false);

  toggled = output<void>();

  protected onClick(): void {
    if (!this.disabled()) {
      this.toggled.emit();
    }
  }
}
